
import model1 from "../assets/models/ren.glb"
import model2 from "../assets/models/ren.glb"
import model3 from "../assets/models/ren.glb"
import model4 from "../assets/models/castsync.glb"

export const productsData = [
    {
        id: "countsync",
        name: "CountSync",
        image: model1,
        shortDesc: "Accurate production tracking device.",
        longDesc:
            "It tracks the exact number of parts produced or processed.It ensures accurate production records and helps verify operator efficiency",
        features: [
            {
                icon: "fa fa-area-chart",
                title: "Multi-Metric Tracking",
                desc: "Tracks RPM, count, length, or any machine-specific parameters."
            },
            {
                icon: "fa fa-industry",
                title: "Industry Versatility",
                desc: "Works with multiple industries and machine types without customization."
            },
            {
                icon: "	fa fa-server",
                title: "Live Dashboards",
                desc: "Provides real-time dashboard visibility for all connected machines."
            },
            {
                icon: "fa fa-bell",
                title: "Instant Alerts",
                desc: "Detects anomalies and downtime with instant notifications."
            }
        ],

        detailDecs: [
            {
                id: 1,
                que: "What CountSync Does",
                ans: "CountSync captures machine metrics such as RPM, count, length, and other production indicators, offering universal compatibility across different industries and machine types."
            },
            {
                id: 2,
                que: "Who It Is For",
                ans: "Ideal for textile units, fabrication plants, packaging lines, material processing units, automotive suppliers, and any industry that relies on continuous machine operations."
            },
            {
                id: 3,
                que: "Why It’s Useful",
                ans: "It provides real-time monitoring, instant anomaly detection, and plug-and-play setup, helping manufacturers maintain consistent output, reduce downtime, and optimize machine performance."
            }
        ],

        specs: [
            { label: "Power Supply", value: "24V DC / 2A" },
            { label: "Connectivity", value: "Wi-Fi / GSM" },
            // { label: "Sensor Inputs", value: "Proximity, IR Sensor, Photoelectric " },
            { label: "Data Storage", value: "Cloud " },
            { label: "Installation Type", value: "Plug-and-play" }
        ]

    },
    {
        id: "timesync",
        name: "TimeSync",
        image: model2,
        shortDesc: "Smart machine runtime monitoring.",
        longDesc:
            "Timer captures precise machine running, idle, and total operating time. It helps manufacturers track productivity, downtime, and improve OEE.",
        features: [
            {
                icon: "fa fa-clock-o",
                title: "Accurate Timing",
                desc: "Measures machine operating time with precision."
            },
            {
                icon: "fa fa-refresh",
                title: "Complete Time Breakdown",
                desc: "Tracks runtime, idle time, and cycle time."
            },
            {
                icon: "fa fa-bar-chart",
                title: "OEE Ready",
                desc: "Enables seamless OEE calculation and performance analysis."
            },
            {
                icon: "fa fa-cloud",
                title: "Cloud Storage",
                desc: "Stores data securely on cloud for long-term analysis."
            }
        ],

        detailDecs: [
            {
                id: 1,
                que: "What TimeSync Does",
                ans: "TimeSync precisely measures machine operating time, runtime, cycle time, and idle time, and supports accurate OEE calculations."
            },
            {
                id: 2,
                que: "Who It Is For",
                ans: "Designed for general manufacturing, assembly lines, and process plants where exact time measurement is critical for production."
            },
            {
                id: 3,
                que: "Why It’s Useful",
                ans: "It eliminates manual reporting errors and provides transparent performance analytics. Helps optimize shift planning, machine utilization, and operational efficiency."
            }
        ],

        specs: [
            { label: "Power Supply", value: "24V DC / 2A" },
            { label: "Connectivity", value: "Wi-Fi / GSM" },
            // { label: "Sensor Inputs", value: "Clamp sensor, Limit Switch " },
            { label: "Data Storage", value: "Cloud" },
            { label: "Installation Type", value: "Plug-and-play" }
        ]

    },
    {
        id: "stitchsync",
        name: "StitchSync",
        image: model3,
        shortDesc: "Smart sewing machine monitoring.",
        longDesc:
            "StitchSync monitors every sewing machine in real time, capturing production counts, runtime, and operator activity with precision.",
        features: [
            {
                icon: "fa fa-tachometer",
                title: "Real-Time Tracking",
                desc: "Tracks stitch counts and production output live."
            },
            {
                icon: "fa fa-barcode",
                title: "RFID Login",
                desc: "Captures operator login and identity through RFID."
            },
            {
                icon: "fa fa-laptop",
                title: "Machine Monitoring",
                desc: "Monitors runtime, idle time, and downtime for every machine."
            },
            {
                icon: "fa fa-cogs",
                title: "Efficiency Insights",
                desc: "Shows operator efficiency and daily performance metrics."
            },
            {
                icon: "fa fa-area-chart",
                title: "Auto Reporting",
                desc: "Provides automated production reports and dashboard summaries."
            }
        ],
        detailDecs: [
            {
                id: 1,
                que: "What StitchSync Does",
                ans: "StitchSync monitors every sewing machine in real time, capturing stitch counts, production output, operator login, runtime, idle time, and downtime with complete accuracy."
            },
            {
                id: 2,
                que: "Who It Is For",
                ans: "Designed for garment factories, bag manufacturing units, upholstery stitching units, and any sewing-based production line."
            },
            {
                id: 3,
                que: "Why It’s Useful",
                ans: "It eliminates manual errors, removes supervisor bias, improves transparency, and gives owners complete clarity on worker efficiency, machine health, and daily production. This leads to higher output, better accountability, and smarter decision-making."
            }

        ],
        specs: [
            { label: "Power Supply", value: "24V DC / 2A" },
            { label: "Connectivity", value: "Wi-Fi / GSM" },
            // { label: "Sensor Inputs", value: "RFID reader, IR sensor, Optical sensor " },
            { label: "Data Storage", value: "Cloud" },
            { label: "Installation Type", value: "Plug-and-play" }
        ]
    },
    {
        id: "castsync",
        name: "CastSync",
        image: model4,
        shortDesc: "Industrial runtime tracking device.",
        longDesc:
            "The device records precise machine runtime, idle time, and production activity while tracking operator performance in real time.",

        features: [
            {
                
                icon: "fa fa-clock-o",
                title: "Precision Runtime",
                desc: "Captures exact machine runtime, idle time, and weld cycles."
            },
            {
                icon: "fa fa-user",
                title: "Operator Tracking",
                desc: "Logs operator activity and performance during operations."
            },
            {
                icon: "fa fa-podcast",
                title: "Real-Time Output",
                desc: "Provides real-time visibility on casting and welding production."
            },
            {
                icon: "fa fa-warning",
                title: "Efficiency Detection",
                desc: "Highlights inefficiencies to reduce rework and improve throughput."
            },
            {
                icon: "fa fa-refresh",
                title: "Shift Reporting",
                desc: "Generates accurate production and shift-wise reports automatically."
            }
        ],

        detailDecs: [
            {
                id: 1,
                que: "What CastSync Does",
                ans: "CastSync tracks machine runtime, idle time, weld cycles, and operator performance in real time for cast-welding and fabrication environments. It shows live production activity and highlights inefficiencies with precision."
            },
            {
                id: 2,
                que: "Who It Is For",
                ans: "Built for cast-welding units, fabrication shops, foundries, and heavy industrial production where accuracy and safety are critical."
            },
            {
                id: 3,
                que: "Why It’s Useful",
                ans: "It helps manufacturers reduce rework, understand operator productivity, and maintain full visibility of welding operations. This ensures better quality control, higher output, and more predictable shift performance."
            }
        ],

        specs: [
            { label: "Power Supply", value: "24V DC / 2A" },
            { label: "Connectivity", value: "Wi-Fi / Ethernet" },
            // { label: "Sensor Inputs", value: "Weld cycle sensor, proximity, RFID" },
            { label: "Data Storage", value: "Cloud" },
            { label: "Installation Type", value: "Plug-and-play" }
        ]
    }
];
 